import { render } from "./ChooseAvatarHigh.vue?vue&type=template&id=46ead662&scoped=true"
import script from "./ChooseAvatarHigh.vue?vue&type=script&lang=js"
export * from "./ChooseAvatarHigh.vue?vue&type=script&lang=js"

import "./ChooseAvatarHigh.vue?vue&type=style&index=0&id=46ead662&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46ead662"],['__file',"src/components/start/ChooseAvatarHigh.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46ead662"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46ead662', __exports__)) {
    api.reload('46ead662', __exports__)
  }
  
  module.hot.accept("./ChooseAvatarHigh.vue?vue&type=template&id=46ead662&scoped=true", () => {
    api.rerender('46ead662', render)
  })

}


export default __exports__